import type { Currency } from '../../../constants';
import { OrderStatus, type DeliveryTrackingStatus } from '../../../constants/order';

export interface DeleoTraceEvent {
  detailStatus: string | null;
  eventTime: string;
  description: string;
  location: string | null;
  empNm: string | null;
  status: DeliveryTrackingStatus;
}

export interface TrackingEvent {
  id: string;
  type: DeliveryTrackingStatus;
  title: string;
  timestamp: string;
  description?: string;
  status: 'completed' | 'current' | 'pending';
}

export interface OrderLineItem {
  itemId: string;
  productId?: string;
  parentProductId?: string;
  name: string;
  nameKor?: string;
  originalName?: string;
  sku: string;
  quantity: number;
  price?: number;
  total?: number;
  subtotal?: number;
  productSize?: string;
  productPack?: string;
  wooCommerceImageUrl?: string;
  inboundStatus?: string;
  sourcingRoute?: string;
  deliveryCompanyCd?: string;
  brand?: string;
  category?: string;
}

export interface OrderAddress {
  firstName: string;
  lastName: string;
  company?: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
  phone?: string;
  email?: string;
}

export interface DeleoData {
  deleoOrderId: string;
  deleoTrackingNo: string;
  deleoStatus: {
    name: string;
    code: string;
    desc: string;
  };
  deliveryTrace?: {
    orderId: string;
    status: {
      name: string;
      code: string;
      desc: string;
    };
    traceInfoList: Array<{
      mainTrackingNo: string;
      trackingNo: string;
      description: string;
      status: string;
      origin: string;
      dest: string;
      deliveryCompanyCode: {
        name: string;
        code: string;
        desc: string;
      };
      traceList: DeleoTraceEvent[];
    }>;
  };
  orderItemList?: Array<{
    orderItemId: string;
    itemCd: string;
    itemNm: string;
    quantity: number;
    amt: number;
    status: {
      name: string;
      code: string;
      desc: string;
    };
  }>;
}

export interface Order {
  orderId: string;
  status: OrderStatus;
  currency: Currency;
  totalAmount: number;
  discount?: number;
  orderDate: string;
  orderDateTime: string;
  createdAt: string;
  updatedAt: string;
  customerId: string;
  customer: {
    id: string;
    name: string;
    email: string;
    phone: string;
  };
  lineItems: OrderLineItem[];
  shippingAddress: OrderAddress;
  billingAddress: OrderAddress;
  deleoData?: DeleoData;
  shippingMessage?: string;
  pic?: string;
}


export type GetOrderRequest = {
  orderId: number;
  sessionKey?: string;
};

export type GetOrderResponse = Order;

export type GetOrdersRequest = {
  page?: number;
  perPage?: number;
  status?: OrderStatus;
  sessionKey?: string;
  customerId?: number;
};

export type GetOrdersResponse = {
  orders: Order[];
  total: number;
  totalPages: number;
};

export type GetUserOrdersRequest = {
  userId: number;
};

export type GetUserOrdersResponse = {
  orderIds: string[];
};

